import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  OrganizationalStructureDetailsState,
  OrganizationalStructureDetailsAction,
  OrganizationalStructureDetailsReducer,
} from './organizational-structure-details-reducer';

const initialState: OrganizationalStructureDetailsState = {
  organizationalStructureDetails: null,
  loading: false,
};

const OrganizationalStructureDetailsStateContext = createContext<OrganizationalStructureDetailsState | undefined>(undefined);
const OrganizationalStructureDetailsDispatchContext = createContext<React.Dispatch<OrganizationalStructureDetailsAction> | undefined>(undefined);

interface OrganizationalStructureDetailsProviderProps {
  children: ReactNode;
}

export const OrganizationalStructureDetailsProvider: React.FC<OrganizationalStructureDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(OrganizationalStructureDetailsReducer, initialState);

  return (
    <OrganizationalStructureDetailsStateContext.Provider value={state}>
      <OrganizationalStructureDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </OrganizationalStructureDetailsDispatchContext.Provider>
    </OrganizationalStructureDetailsStateContext.Provider>
  );
};

export const useOrganizationalStructureDetailsState = (): OrganizationalStructureDetailsState => {
  const context = useContext(OrganizationalStructureDetailsStateContext);
  if (context === undefined) {
    throw new Error('useOrganizationalStructureDetailsState must be used within a OrganizationalStructureDetailsProvider');
  }
  return context;
};

export const useOrganizationalStructureDetailsDispatch = (): React.Dispatch<OrganizationalStructureDetailsAction> => {
  const context = useContext(OrganizationalStructureDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('useOrganizationalStructureDetailsDispatch must be used within a OrganizationalStructureDetailsProvider');
  }
  return context;
};